<!-- Energy widget version badge (dev overlay) -->
<script lang="ts">
	export let version: string;
	export let componentName: string | undefined;
</script>

<span class="energy-widget-version-badge" aria-hidden="true">
	<span class="energy-widget-version-badge-version">ver. {version}</span>
	{#if componentName}
		<span class="energy-widget-version-badge-component">{componentName}</span>
	{/if}
</span>

<style>
	.energy-widget-version-badge {
		position: absolute;
		top: 4px;
		right: 6px;
		z-index: 5;
		display: flex;
		flex-direction: column;
		align-items: flex-end;
		gap: 2px;
		max-width: 160px;
		pointer-events: none;
		user-select: none;
	}

	.energy-widget-version-badge-version {
		font-size: 9px;
		line-height: 1;
		font-weight: 600;
		letter-spacing: 0.02em;
		color: var(--color-primary);
	}

	.energy-widget-version-badge-component {
		font-size: 6px;
		line-height: 1.15;
		font-weight: 500;
		letter-spacing: 0.01em;
		color: var(--color-primary);
		opacity: 0.75;
		text-align: right;
		word-break: break-all;
	}
</style>
